import fileSaver from 'file-saver';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import t from './product.type';
import * as productAttribute from '../../../../services/productAttributes';
import { ERROR_MESSAGE } from '../../../../Components/helper';

export const getAllUsageProducts = (data) => async (dispatch) => {
  try {
    const res = await productAttribute.getAllUsageProductList(data);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_PRODUCTS,
        payload: { data: res?.data?.data, totalCount: res?.data?.totalCount, searchText: data.searchText, isScrolled: data.isScrolled },
      });
    }
    return res?.data?.data;
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const getAllFactories = (data) => async (dispatch) => {
  try {
    const res = await productAttribute.getAllFactoriesList(data);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_FACTORIES,
        payload: res.data,
      });
    }
    return true;
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const clearProducts = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_REDUCER,
    });
  } catch (err) {
    console.log('............', err);
  }
};

export const saveUsageProducts = (data, transactionMsg) => async () => {
  try {
    const res = await productAttribute.AddUsageProduct(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_USAGE.${res?.data?.message}`);
      if (data?.devOrderId?.length === 1 && res?.data?.count === 1) {
        toasterMsg('Product is already added.', 'danger');
        return true;
      }
      toasterMsg(msg, 'success');
      if (res?.data?.count > 0) {
        toasterMsg('Some Products are already added.', 'danger');
      }
    } else {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const updateUsageProducts = (data, transactionMsg) => async () => {
  try {
    const res = await productAttribute.updateUsageProduct(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_USAGE.${res?.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = transactionMsg(res?.data?.errMsg);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const deleteUsageProducts = (deldata, transactionMsg) => async () => {
  try {
    const res = await productAttribute.deleteUsageProduct(deldata);
    if (res?.code === 200) {
      const msg = transactionMsg(`${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const updateTotalCount = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UPDATE_TOTAL_COUNT,
    });
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

/**
 * Downloads the BOM usage spreadsheet for a product or a BOM library.
 * The saved name carries the .xlsx extension explicitly, since the response is an unnamed Blob and a
 * name without an extension is rejected by Excel as an unrecognised file.
 * @param {object} data Export parameters, including bomName and isBomLibrary.
 * @param {Function} translation i18n translate function.
 * @returns {Function} Thunk resolving once the download has been triggered.
 */
export const downloadBomAttribute = (data, translation) => async () => {
  try {
    const res = await productAttribute.exportBOMUsageDetails(data);

    if (res?.errMsg) {
      toasterMsg(translation(res.errMsg), 'danger');
      return;
    }
    if (!(res instanceof Blob)) {
      toasterMsg(ERROR_MESSAGE, 'danger');
      return;
    }

    const usageLabel = data?.isBomLibrary ? 'BOM Library Usage' : 'BOM Product Usage';
    fileSaver.saveAs(res, `${data?.bomName}-${usageLabel}.xlsx`);
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
